/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import ViolationFeesContainer from './violation_fees/container/ViolationFeesContainer';
import ApprehendingOfficersContainer from './apprehending_officers/container/ApprehendingOfficersContainer';
import ImportCsvContainer from './import-csv/container/ImportCsvContainer';
import TaxAmnestyContainer from './taxAmnesty/container/TaxAmnestyContainer';

function OVRSSettings({ match, pathName }) {
  const permissions = getJson('permissions');
  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              <li className="nav-item">
                <Link
                  to="/ordinance-violation-receipts/settings/violation-fees"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf(
                      'ordinance-violation-receipts/settings/violation-fees'
                    ) > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Traffic Violation Matrix
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/ordinance-violation-receipts/settings/apprehending-officers"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf(
                      'ordinance-violation-receipts/settings/apprehending-officers'
                    ) > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Apprehending Officers
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/ordinance-violation-receipts/settings/import-csv"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf(
                      'ordinance-violation-receipts/settings/import-csv'
                    ) > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Import CSV
                </Link>
              </li>
              {Acl(permissions, ['VIEW OVRS TAX AMNESTY']) && (
                <li className="nav-item">
                  <Link
                    to="/ordinance-violation-receipts/settings/tax-amnesty"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf(
                        'ordinance-violation-receipts/settings/tax-amnesty'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Tax Amnesty
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/violation-fees`} />}
          />
          <Route
            path={`${match.path}/violation-fees`}
            component={ViolationFeesContainer}
          />
          <Route
            path={`${match.path}/apprehending-officers`}
            component={ApprehendingOfficersContainer}
          />
          <Route
            path={`${match.path}/import-csv`}
            component={ImportCsvContainer}
          />
          {Acl(permissions, ['VIEW OVRS TAX AMNESTY']) && (
            <Route
              path={`${match.path}/tax-amnesty`}
              component={TaxAmnestyContainer}
            />
          )}
        </Switch>
      </div>
    </React.Fragment>
  );
}

OVRSSettings.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(OVRSSettings);
